"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishPage = void 0;
const commands_1 = require("../models/commands");
const interfaces_1 = require("../models/interfaces");
class PublishPage extends interfaces_1.CommandBase {
    constructor(cmd) {
        super(commands_1.Command.PublishPage, cmd);
    }
}
exports.PublishPage = PublishPage;
//# sourceMappingURL=publishPage.js.map